<template>
  <el-form :inline="true" :model="searchForm" class="top-form">
    <el-form-item label="时间范围">
      <el-date-picker
        v-model="searchForm.time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="onSubmit">搜索</el-button>
      <el-button icon="el-icon-refresh-left" @click="onReset">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSettingDate } from '@/util/date'

function defaultTimeRange() {
  return [
    getSettingDate('daySLast7', { format: 'YYYY-MM-DD' }),
    getSettingDate('dayE', { format: 'YYYY-MM-DD' })
  ]
}

export default {
  name: 'HistoricalReviewTopForm',
  data() {
    return {
      searchForm: {
        time: defaultTimeRange()
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              picker.$emit('pick', defaultTimeRange())
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              picker.$emit('pick', [
                getSettingDate('daySLast30', { format: 'YYYY-MM-DD' }),
                getSettingDate('dayE', { format: 'YYYY-MM-DD' })
              ])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              picker.$emit('pick', [
                getSettingDate('daySLast90', { format: 'YYYY-MM-DD' }),
                getSettingDate('dayE', { format: 'YYYY-MM-DD' })
              ])
            }
          }
        ]
      }
    }
  },
  methods: {
    onSubmit() {
      const time = this.searchForm.time || []
      if (!time.length || !time[0] || !time[1]) {
        this.$message.warning('请选择时间范围')
        return
      }
      this.$emit('search', {
        startTime: time[0],
        endTime: time[1]
      })
    },
    onReset() {
      this.searchForm.time = defaultTimeRange()
      this.onSubmit()
    }
  }
}
</script>

<style scoped lang="scss">
.top-form {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  ::v-deep .el-form-item {
    margin-right: 10px;
    margin-bottom: 0;
  }

  ::v-deep .el-form-item:last-child {
    margin-right: 0;
  }

  ::v-deep .el-form-item__label {
    padding-right: 8px;
    color: #64748b;
    font-weight: 500;
  }

  ::v-deep .el-date-editor {
    width: 292px;
    border-color: #dbe3ef;
    border-radius: 6px;
  }

  ::v-deep .el-date-editor .el-range-input {
    color: #334155;
  }

  ::v-deep .el-date-editor .el-range-separator {
    color: #94a3b8;
  }

  ::v-deep .el-button {
    min-width: 78px;
    height: 34px;
    padding: 8px 15px;
    border-radius: 6px;
  }

  ::v-deep .el-button--primary {
    background: #2563eb;
    border-color: #2563eb;
    box-shadow: 0 6px 14px rgba(37, 99, 235, .18);
  }
}
</style>
